import React from 'react';

import { useCustomerReturnShippingWidgetQuery } from 'generated/graphql';



export interface IData {
  trackingUrl: string;
  trackingNumber: string;
  labelUrl: string;
}

export function useQuery(returnAuthorizationId: string) {
  const tuple = useCustomerReturnShippingWidgetQuery({
    variables: {
      returnAuthorizationId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        trackingUrl: tuple.data?.returnAuthorizationLite?.shipment?.trackingUrl ?? '',
        trackingNumber: tuple.data?.returnAuthorizationLite?.shipment?.trackingNumber ?? '',
        labelUrl: tuple.data?.returnAuthorizationLite?.shipment?.labelUrl ?? ''
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
